export const cn = (...classes) => {
    return classes.filter(Boolean).join(" ");
};
/**
 * Русское склонение числительного (1 трек / 2 трека / 5 треков).
 *
 * Живёт в `shared`, а не рядом с первым потребителем: формами пользуются и
 * центр уведомлений (перечисление начислений), и подпись списка «Мои песни» —
 * второй копии склонятора быть не должно.
 */
export const pluralRu = (n, one, few, many) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11)
        return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return few;
    return many;
};
export const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("ru-RU");
};
export const storage = {
    get: (key, defaultValue) => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        }
        catch {
            return defaultValue;
        }
    },
    set: (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            console.error("Error saving to localStorage:", error);
        }
    },
    remove: (key) => {
        try {
            localStorage.removeItem(key);
        }
        catch {
            /* private mode / SecurityError */
        }
    },
};
/**
 * Адрес почты.
 *
 * Заякорен (почта посреди фразы — не почта) и не пропускает символы, которыми
 * почтовый клиент обрамляет адрес при копировании: `<ivan@example.com>`,
 * `"ivan@example.com"`, `ivan@example.com;`, `mailto:ivan@example.com`. Такой
 * адрес доезжает до `billing_email`, и чек по 54-ФЗ уходит в никуда.
 *
 * Домен — непустые метки через точку: `example.com` подходит, а
 * `example.com.` (тоже частый хвост копипасты) и `example..com` — нет.
 *
 * Юникод намеренно НЕ запрещаем: `иван@почта.рф` — рабочий адрес, и сузить
 * класс до латиницы значило бы отвергать живые адреса.
 */
const EMAIL_RE = /^[^\s@<>(),;:\\"[\]]+@[^\s@<>(),;:\\".[\]]+(?:\.[^\s@<>(),;:\\".[\]]+)+$/;
/**
 * Канон адреса: домен — в нижний регистр, локальная часть — как ввёл человек.
 *
 * Домен регистронезависим по DNS, поэтому `Example.COM` и `example.com` — один
 * и тот же почтовый сервер. А вот локальная часть по RFC 5321 регистрозависима,
 * и «чинить» её за пользователя нельзя: формально `Ivan@` и `ivan@` — разные
 * ящики. Один канон на оба поля почты в проекте (контакт в заявке и
 * `billing_email`), чтобы двух разных «почт» у одного человека не заводилось.
 */
export const normalizeEmail = (email) => {
    const trimmed = email.trim();
    const at = trimmed.lastIndexOf("@");
    if (at === -1)
        return trimmed;
    return trimmed.slice(0, at) + trimmed.slice(at).toLowerCase();
};
export const validators = {
    email: (email) => {
        return EMAIL_RE.test(email);
    },
    password: (password) => {
        return password.length >= 6;
    },
};
